import React from "react";

//UI
import { Skeleton, Tooltip, Row, Col } from "antd";
import { ButtonLink } from "../Common/Button/index";
import { HomePageHeader, HeaderLeftItemsWrapper } from "../Common/UIElements";

const AddUserPopertyTopBar = (props) => {
  const { addProperty, isAddPropertyDisabled } = props;

  return (
    <div className="full-width">
      <Skeleton loading={false} active>
        <HomePageHeader>
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <HeaderLeftItemsWrapper>
              <Col xxl={20} xl={20} lg={20} md={12} sm={24} xs={24}>
                <div>
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    Property Uploader
                  </span>
                </div>
              </Col>
              <Col xxl={4} xl={4} lg={4} md={12} sm={24} xs={24}>
                <Tooltip placement="bottomRight" title="Add Property Manually">
                  <ButtonLink
                    onClick={() => {
                      addProperty();
                    }}
                    size="large"
                    disabled={isAddPropertyDisabled}
                  >
                    <span style={{ textDecoration: "underline" }}>
                      Add Property Manually
                    </span>
                  </ButtonLink>
                </Tooltip>
              </Col>
            </HeaderLeftItemsWrapper>
          </Col>
        </HomePageHeader>
      </Skeleton>
    </div>
  );
};

export default AddUserPopertyTopBar;
